import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const CHECK_IN_STATE = ['notAttend', 'attended']
const STATE = ['waitList', 'registeredNotConfirmed', 'registered', 'cancelled', 'transferred', 'registeredNotSuccess']

export const schema = Joi.object().keys({
	check_in_state: Joi.string().valid(CHECK_IN_STATE).allow(''),
	state: Joi.string().valid(STATE).allow(''),
});

export default function updateAttendee(attendeeId, attendeeInfo) {

  if(!attendeeId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing ticket ID')
      })
    })
  }

  let validateResult = Joi.validate(attendeeInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	let toServer = {
		...attendeeInfo
	}

	if(typeof(attendeeInfo.check_in_state) != 'undefined'){
		toServer.check_in_state = CHECK_IN_STATE.indexOf(attendeeInfo.check_in_state)
	}
	if(typeof(attendeeInfo.state) != 'undefined'){
		toServer.state = STATE.indexOf(attendeeInfo.state)
	}


  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_attendee/${attendeeId}/`,
      'method': 'PUT',
      'data': JSON.stringify(toServer),
      'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/ticket/updateAttendee.js